import { useEffect } from "react"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

const DONATION_OPTIONS = [
  { amount: 5, href: "https://pycmt.me/EkMPB" },
  { amount: 10, href: "https://pycmt.me/dkA4M" },
  { amount: 15, href: "https://pycmt.me/ha6o9" },
  { amount: 50, href: "https://pycmt.me/8uaMD" },
  { amount: 100, href: "https://pycmt.me/ewYPE" },
  { amount: 150, href: "https://pycmt.me/JPkmx" },
]

const DonacionsPasstorets = () => {
  useEffect(() => {
    document.title = "Els Nous Pastorets"

    let metaRobots = document.querySelector('meta[name="robots"]')
    if (!metaRobots) {
      metaRobots = document.createElement("meta")
      metaRobots.name = "robots"
      document.head.appendChild(metaRobots)
    }
    metaRobots.content = "noindex, nofollow"

    return () => {
      metaRobots.remove()
    }
  }, [])

  return (
    <div className="flex flex-col" style={{ minHeight: "calc(100vh - 48px)" }}>
      <Navbar />

      <div className="flex-1 flex flex-col items-center border-r border-b border-l border-blue px-6 py-6 gap-5">

        <h1 className="text-2xl sm:text-3xl lg:text-5xl text-blue font-brik uppercase text-center leading-tight max-w-lg">
          Fem possible la renovació d'Els Pastorets
        </h1>

        {/* Substitueix /pastorets-renovacio.jpg per la imatge definitiva */}
        <div className="w-full max-w-lg overflow-hidden" style={{ maxHeight: "220px" }}>
          <img
            src="https://www.joventutdelafarandula.cat/img/pastorets-renovacio.jpg"
            alt="Els Nous Pastorets"
            className="w-full h-full object-cover rounded"
            style={{ maxHeight: "220px" }}
          />
        </div>

        <p className="text-blue font-mori text-l uppercase text-center">Fes una donació i col·labora a fer els nous pastorets</p>

        <div className="grid grid-cols-2 gap-3 w-full max-w-xs">
          {DONATION_OPTIONS.map(({ amount, href }) => (
            <a
              key={amount}
              href={href}
              className="bg-blue text-gray font-brik text-xl uppercase text-center py-5 border rounded border-blue hover:bg-gray hover:text-blue transition-colors"
            >
              {amount} €
            </a>
          ))}
        </div>

        <p className="text-blue font-mori text-center text-sm max-w-sm mt-auto pt-2">
          Formaràs part del mural de col·laboradors. Si no hi vols sortir envia un correu a: <br /> {" "}
          <a
            href="mailto:secretaria@joventutdelafarandula.cat"
            className="underline font-bold break-all"
          >
            secretaria@joventutdelafarandula.cat
          </a>
        </p>
        <p className="text-blue font-mori text-center text-xs max-w-sm mt-auto pt-2">
          Aquesta aportació no serà deduïble fiscalment
        </p>

      </div>
      <Footer />
    </div>
  )
}

export default DonacionsPasstorets
